import { useTheme } from "@emotion/react";
import {
  AccessTimeOutlined,
  AddOutlined,
  Cached,
  CheckOutlined,
  Clear,
  ClearOutlined,
  ErrorOutlineOutlined,
  FilterAltOutlined,
  KeyboardDoubleArrowRightOutlined,
  Search,
  SearchOutlined,
  SettingsOutlined,
  TravelExploreOutlined,
} from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Box,
  Button,
  Chip,
  CircularProgress,
  Divider,
  Drawer,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  lighten,
  MenuItem,
  Modal,
  Paper,
  Select,
  Snackbar,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useOutletContext } from "react-router-dom";
import ConfusedMaleNoBack from "../../../../components/artsPersonComponent/confusedMaleNoBack";
import ConfusedMale from "../../../../components/artsPersonComponent/confusedMale";
import InformationMaleNoBack from "../../../../components/artsPersonComponent/informationMaleNoBack";
import LoaderThreeDots from "../../../../components/loadingAnimation";
import InternoModalConfirmacaoSaida from "../../../../components/modalSaindoDaPagina";
import SelectFilter from "../../../../components/selectFilter";
import StackedBarChart from "../../../../components/stackedBarChart";
import TicketModalContent from "../../../../components/tickets/detailsTicketComponent";
import TicketModalContentIxc from "../../../../components/tickets/detailsTicketIxcComponent";
import ModalConfigSla from "../../../../components/tickets/modalConfigSla";
import ModalNewTicket from "../../../../components/tickets/modalNewTicket";
import ModalNewTicketIxc from "../../../../components/tickets/modalNewTicketIxc";
import OsModalComponent from "../../../../components/tickets/osModalComponent";
import FilterBar from "../../../../components/topBarFilter";
import VirtualizedAutocomplete from "../../../../components/virtualization/virtualizedAutocomplete";
import FluxoAtendimento from "../fluxoAtendimento";
import FluxoAtendimentoIxc from "../fluxoAtendimentoIxc";
import FluxoTickets from "../FluxoTickets";
import useStyles from "./styles";

const configParamsErp = (params) => {
  const erp = window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP;

  switch (params) {
    case "filial":
      return erp === "IXC" ? "Filial" : "Local";
      break;
    case "assunto":
      return erp === "IXC" ? "Assunto" : "Solicitação";
      break;
  }
};

export default function Atendimentos() {
  const { controllerDashboard, setControllerDashboard, api } =
    useOutletContext();
  const [fluxoAtendimento, setFluxoAtendimento] = useState([]);
  const [countAtendimentos, setCountAtendimentos] = useState(0);
  const [selectEtapaFluxo, setSelectEtapaFluxo] = useState(null);
  const [selectEtapa, setSelectEtapa] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingSla, setLoadingSla] = useState(false);
  const [isEditConfigSla, setIsEditConfigSla] = useState(false);
  const [snackbar, setSnackbar] = useState(null);
  const [buscarTicket, setBuscarTicket] = useState("");
  const [isSelecting, setIsSelecting] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [filterAtendimentos, setFilterAtendimentos] = useState([]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [open, setOpen] = useState(false);
  const [openModalEtapa, setOpenModalEtapa] = useState(false);
  const [objectEtapas, setObjectEtapas] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [newMensagem, setNewMensagem] = useState("");
  const [newEtapa, setNewEtapa] = useState({});
  const [error, setError] = useState(false);
  const [editedTicket, setEditedTicket] = useState(null);
  const [openSearch, setOpenSearch] = useState(false);
  const [openConfigSla, setOpenConfigSla] = useState(false);
  const [configSla, setConfigSla] = useState([]);
  const [searchValueProtocolo, setSearchValueProtocolo] = useState("");
  const [ticketDetails, setTicketDetails] = useState(null);
  const [value, setValue] = useState(0);
  const [editEtapasConfigSla, setEditEtapasConfigSla] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [tecnicos, setTecnicos] = useState([]);
  const [tecnicosSelecionados, setTecnicosSelecionados] = useState([]);
  const [assuntos, setAssuntos] = useState([]);
  const [assuntosSelecionados, setAssuntosSelecionados] = useState([]);
  const [disabledSendFluxo, setDisabledSendFluxo] = useState(false);
  const [allEtapasFluxoAtendimento, setAllEtapasFluxoAtendimento] = useState(
    [],
  );
  const [typeSearch, setTypeSearch] = useState("ticket");
  const [osDetails, setOsDetails] = useState(null);
  const [isEditTicket, setIsEditTicket] = useState(false);
  const [isFinishTicket, setIsFinishTicket] = useState(false);
  const [isEditOs, setIsEditOs] = useState(false);
  const [confirmacaoSaidaPagina, setConfirmacaoSaidaPagina] = useState(false);
  const [isNewOs, setIsNewOs] = useState(false);

  const [openNewTicket, setOpenNewTicket] = useState(false);

  const [prioridades, setPrioridades] = useState([]);
  const [prioridadesSelecionados, setPrioridadesSelecionados] = useState([]);

  const [filiais, setFiliais] = useState([]);
  const [filiaisSelecionados, setFiliaisSelecionados] = useState([]);

  const [isExplicacao, setIsExplicacao] = useState(true);
  const [loadingTicketDetails, setLoadingTicketDetails] = useState(false);
  const [itensPublic, setItensPublic] = useState({
    mensagens: [],
    anexos: [],
    rfo: [],
  });
  const [openModalAlertPrioridade, setOpenModalAlertPrioridade] =
    useState(false);

  const [statusTicketMensagem, setStatusTicketMensagem] = useState({});
  const [loadingCreateMensagem, setLoadingCreateMensagem] = useState(false);
  const [loadingEditFluxo, setLoadingEditFluxo] = useState(false);
  const [filaSlaExcedido, setFilaSlaExcedido] = useState([]);
  // 1. Guardamos os intervalos ativos por ID da etapa para não duplicar/resetar
  const activeIntervalsRef = useRef({});
  // 2. Guardamos o fluxo atualizado para o setInterval sempre ler o dado novo
  const fluxoRef = useRef(fluxoAtendimento);
  /*   const initialCheckDone = useRef(false); */
  const etapasVerificadasRef = useRef(new Set());
  const modalAlertSlaAberto = filaSlaExcedido?.length > 0;
  const modalAlerSlaAtual = filaSlaExcedido[0];

  const [isVerificationTicketSlaExcedido, setIsVerificationTicketSlaExcedido] =
    useState(false);
  let userErpId = JSON.parse(localStorage.getItem("user"))?.usuario?.userErpId;
  userErpId = userErpId ? Number(userErpId) : null;

  useEffect(() => {
    fluxoRef.current = fluxoAtendimento;
  }, [fluxoAtendimento]);

  useEffect(() => {
    if (
      !fluxoAtendimento ||
      fluxoAtendimento?.length === 0 ||
      !userErpId ||
      isVerificationTicketSlaExcedido
    ) {
      return;
    }

    fluxoAtendimento.forEach((etapa) => {
      const etapaId = etapa.idEtapaFluxoAtendimento;

      // --- VERIFICAÇÃO 1: SLA REGULAR ---
      if (etapa.actionSla === 1 && etapa.timeAction > 0) {
        if (!etapasVerificadasRef.current.has(`${etapaId}-regular`)) {
          verificarSlaExpirado(etapa);
          etapasVerificadasRef.current.add(`${etapaId}-regular`);
        }

        if (!activeIntervalsRef.current[`${etapaId}-regular`]) {
          const intervalTime = etapa.timeAction * 60 * 1000;
          const intervalId = setInterval(() => {
            const etapaAtualizada = fluxoRef.current?.find(
              (e) => e.idEtapaFluxoAtendimento === etapaId,
            );
            if (!isVerificationTicketSlaExcedido && etapaAtualizada) {
              verificarSlaExpirado(etapaAtualizada);
            }
          }, intervalTime);

          activeIntervalsRef.current[`${etapaId}-regular`] = intervalId;
        }
      }

      // --- VERIFICAÇÃO 2: SLA IDLE (INATIVIDADE) ---
      if (etapa.actionSlaIdle === 1 && etapa.timeActionIdle > 0) {
        if (!etapasVerificadasRef.current.has(`${etapaId}-idle`)) {
          verificarSlaIdleExpirado(etapa);
          etapasVerificadasRef.current.add(`${etapaId}-idle`);
        }

        if (!activeIntervalsRef.current[`${etapaId}-idle`]) {
          const intervalTimeIdle = etapa.timeActionIdle * 60 * 1000;
          const intervalId = setInterval(() => {
            const etapaAtualizada = fluxoRef.current?.find(
              (e) => e.idEtapaFluxoAtendimento === etapaId,
            );
            if (!isVerificationTicketSlaExcedido && etapaAtualizada) {
              verificarSlaIdleExpirado(etapaAtualizada);
            }
          }, intervalTimeIdle);

          activeIntervalsRef.current[`${etapaId}-idle`] = intervalId;
        }
      }
    });
  }, [fluxoAtendimento, userErpId, isVerificationTicketSlaExcedido]);

  // Cleanup ao desmontar o componente
  useEffect(() => {
    return () => {
      Object.values(activeIntervalsRef.current).forEach(clearInterval);
      activeIntervalsRef.current = {};
      etapasVerificadasRef.current.clear();
    };
  }, []);
  const pertenceAoUsuario = (atendimento) =>
    atendimento?.usuario_responsavel.some((resp) => resp.id === userErpId);
  const verificarSlaExpirado = (etapa) => {
    if (etapa?.actionSla === 1 && etapa?.atendimentosSlaExcedido?.length > 0) {
      const matchesSla =
        etapa.atendimentosSlaExcedido.filter(pertenceAoUsuario);

      if (matchesSla?.length > 0) {
        const etapaProcessada = {
          ...etapa,
          atendimentos: matchesSla,
          atendimentosSlaExcedido: matchesSla,
          atendimentosCount: matchesSla?.length,
        };

        const mensagem = `Você possui ${matchesSla?.length} atendimento(s) com SLA excedido na etapa ${etapa?.etapaFluxoAtendimento}. Por favor, verificar.`;

        setFilaSlaExcedido((prevFila) => {
          const jaEstaNaFila = prevFila.some(
            (item) =>
              item.etapa.idEtapaFluxoAtendimento ===
                etapa.idEtapaFluxoAtendimento && !item.isIdle,
          );
          if (jaEstaNaFila) return prevFila;
          return [
            ...prevFila,
            { etapa: etapaProcessada, mensagem, isIdle: false },
          ];
        });
      }
    }
  };

  const verificarSlaIdleExpirado = (etapa) => {
    if (
      etapa?.actionSlaIdle === 1 &&
      etapa?.atendimentosSlaExcedidoIdle?.length > 0
    ) {
      const matchesIdle =
        etapa.atendimentosSlaExcedidoIdle.filter(pertenceAoUsuario);

      if (matchesIdle?.length > 0) {
        const etapaProcessada = {
          ...etapa,
          atendimentos: matchesIdle,
          atendimentosSlaExcedidoIdle: matchesIdle,
          atendimentosCount: matchesIdle?.length,
        };

        const mensagem = `Você possui ${matchesIdle?.length} atendimento(s) que excedeu o tempo de INATIVIDADE na etapa ${etapa?.etapaFluxoAtendimento}. Por favor, verificar.`;

        setFilaSlaExcedido((prevFila) => {
          const jaEstaNaFila = prevFila.some(
            (item) =>
              item.etapa.idEtapaFluxoAtendimento ===
                etapa.idEtapaFluxoAtendimento && item.isIdle,
          );
          if (jaEstaNaFila) return prevFila;
          return [
            ...prevFila,
            { etapa: etapaProcessada, mensagem, isIdle: true },
          ];
        });
      }
    }
  };

  const erp = window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP || "";
  const isPropertyColor =
    erp === "IXC" ? true : erp === "VOALLE" ? true : false;
  const labelErp =
    erp === "HUBSOFT"
      ? "Serviços"
      : erp === "VOALLE"
        ? "Contratos"
        : erp === "IXC"
          ? "Contrato"
          : "";

  const labelTabsErp = {
    descricao:
      erp === "HUBSOFT"
        ? "Descrição"
        : erp === "VOALLE"
          ? "Geral"
          : "Descrição",
    mensagens:
      erp === "HUBSOFT"
        ? "Mensagens"
        : erp === "VOALLE"
          ? "Histórico"
          : "Mensagens",
  };
  const theme = useTheme();
  const styles = useStyles(theme);

  const colors =
    erp === "HUBSOFT"
      ? Object.keys(theme.palette.colors)?.filter(
          (color) => color !== "white" && color !== "black",
        )
      : erp === "IXC"
        ? [
            lighten(theme.palette.colors.blue.dark, 0.1),
            theme.palette.cardTrafficData.paperColor.outputData,
            theme.palette.colors.blue.medium,
          ]
        : erp === "VOALLE"
          ? [
              theme.palette.colors.blue.medium,
              theme.palette.cardTrafficData.paperColor.outputData,
              theme.palette.colors.yellow.darker,
            ]
          : Object.keys(theme.palette.colors)?.filter(
              (color) => color !== "white" && color !== "black",
            );

  useEffect(() => {
    getFluxoAtendimento();
    setIsAdmin(handleUsuarioId());
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    handleSelectEtapa();
    setSelectedItems([]);
    setIsSelecting(false);
  }, [fluxoAtendimento, selectEtapa]);

  useEffect(() => {
    setFilterAtendimentos(filtrarAtendimentos(fluxoAtendimento, buscarTicket));
  }, [
    buscarTicket,
    fluxoAtendimento,
    tecnicosSelecionados,
    assuntosSelecionados,
    prioridadesSelecionados,
    filiaisSelecionados,
  ]);
  const handleUsuarioId = () => {
    let result = JSON.parse(localStorage.getItem("user"));

    // Verifica se a propriedade rlPermissoesUsuario existe e é um array
    if (Array.isArray(result?.usuario?.rlPermissoesUsuario)) {
      // Itera sobre o array para verificar se algum objeto contém a propriedade codigoPermissao com valor "ADM"
      for (let permissao of result?.usuario?.rlPermissoesUsuario) {
        if (permissao?.permissao?.codigoPermissao.toUpperCase() === "ADM") {
          return true;
        }
      }
      return false;
    }
  };

  const handleCheckTicketSlaExcedido = () => {
    // Pega o primeiro item da fila (o que está na tela agora)
    const modalAlerSlaAtual = filaSlaExcedido[0];

    if (!modalAlerSlaAtual) return;

    setIsVerificationTicketSlaExcedido(true);

    // Atualiza o fluxo com a etapa específica deste modal
    setFluxoAtendimento([modalAlerSlaAtual.etapa]);

    // Tira o primeiro item da fila.
    // Se tiver mais itens, o modal vai continuar aberto mostrando o próximo.
    setFilaSlaExcedido((prevFila) => prevFila.slice(1));
  };

  // Caso o usuário possa fechar o modal sem clicar em "Verificar"
  const handleCloseModal = () => {
    setFilaSlaExcedido((prevFila) => prevFila.slice(1));
  };
  // alterna modo de seleção
  const handleToggleSelectMode = () => {
    setIsSelecting((prev) => !prev);
    setSelectedItems([]);
  };

  // marca/desmarca um atendimento
  const handleSelectItem = (atendimento) => {
    setSelectedItems((prev) => {
      const exists = prev.some(
        (item) => item.id_atendimento === atendimento.id_atendimento,
      );
      if (exists) {
        return prev.filter(
          (item) => item.id_atendimento !== atendimento.id_atendimento,
        );
      } else {
        return [...prev, atendimento];
      }
    });
  };

  const getFluxoAtendimento = async () => {
    setLoading(true);
    if (controllerDashboard) {
      controllerDashboard.abort();
    }
    const newController = new AbortController();
    const signal = newController.signal;
    setControllerDashboard(newController);

    try {
      const response = await api.get("/interno/ticket/fluxoAtendimento", {
        signal,
      });
      const fluxo = adicionarCores(response?.data?.fluxo);
      const fluxoVerificado = checkEtapaSlaPrioridade(fluxo);

      setTecnicos(response?.data?.tecnicos);
      setAssuntos(response?.data?.assuntos);
      setPrioridades(response?.data?.prioridades);
      setFiliais(response?.data?.filiais);
      setFluxoAtendimento(fluxoVerificado);
      setAllEtapasFluxoAtendimento(response?.data?.allEtapasFluxoAtendimentos);

      setObjectEtapas(
        response?.data?.fluxo?.map((etapa) => {
          return {
            id: etapa?.idEtapaFluxoAtendimento,
            descricao: etapa?.etapaFluxoAtendimento,
          };
        }),
      );

      const totalAtendimentos = response?.data?.fluxo?.reduce(
        (acc, etapa) => acc + etapa?.atendimentos?.length,
        0,
      );
      setCountAtendimentos(totalAtendimentos);
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Erro ao buscar fluxo de atendimento",
        severity: "error",
      });
    } finally {
      setLoading(false);
      setIsVerificationTicketSlaExcedido(false);
    }
  };

  const checkEtapaSlaPrioridade = (fluxo) => {
    // Captura etapas críticas do SLA Normal ou SLA Idle configuradas com ação prioritária (tipo 2)
    const etapasPrioridadeNormal = fluxo.filter(
      (etapa) => etapa?.actionSla === 2 && etapa?.timeAction > 0,
    );
    const etapasPrioridadeIdle = fluxo.filter(
      (etapa) => etapa?.actionSlaIdle === 2 && etapa?.timeActionIdle > 0,
    );

    const etapasProcessadas = [];
    let totalAtendimentosMatches = 0;
    let nomesEtapasExcedidas = [];

    // Processa estouros críticos do SLA Regular
    etapasPrioridadeNormal.forEach((etapa) => {
      if (etapa?.atendimentosSlaExcedido?.length > 0) {
        const matchesSla =
          etapa.atendimentosSlaExcedido.filter(pertenceAoUsuario);
        if (matchesSla?.length > 0) {
          etapasProcessadas.push({
            ...etapa,
            atendimentos: matchesSla,
            atendimentosSlaExcedido: matchesSla,
            atendimentosCount: matchesSla?.length,
          });
          totalAtendimentosMatches += matchesSla.length;
          if (
            etapa?.etapaFluxoAtendimento &&
            !nomesEtapasExcedidas.includes(etapa.etapaFluxoAtendimento)
          ) {
            nomesEtapasExcedidas.push(etapa.etapaFluxoAtendimento);
          }
        }
      }
    });

    // Processa estouros críticos do SLA Idle
    etapasPrioridadeIdle.forEach((etapa) => {
      if (etapa?.atendimentosSlaExcedidoIdle?.length > 0) {
        const matchesIdle =
          etapa.atendimentosSlaExcedidoIdle.filter(pertenceAoUsuario);
        if (matchesIdle?.length > 0) {
          etapasProcessadas.push({
            ...etapa,
            atendimentos: matchesIdle,
            atendimentosSlaExcedidoIdle: matchesIdle,
            atendimentosCount: matchesIdle?.length,
          });
          totalAtendimentosMatches += matchesIdle.length;
          if (
            etapa?.etapaFluxoAtendimento &&
            !nomesEtapasExcedidas.includes(etapa.etapaFluxoAtendimento)
          ) {
            nomesEtapasExcedidas.push(etapa.etapaFluxoAtendimento);
          }
        }
      }
    });

    if (etapasProcessadas.length > 0) {
      setIsVerificationTicketSlaExcedido(true);
      const etapasTexto = nomesEtapasExcedidas.join(", ");

      setOpenModalAlertPrioridade({
        open: true,
        mensagem: `Você possui ${totalAtendimentosMatches} atendimento(s) que excedeu o tempo de INATIVIDADE na etapa [${etapasTexto}] que requer atenção IMEDIATA. Por favor, verificar.`,
      });

      return etapasProcessadas;
    } else {
      setIsVerificationTicketSlaExcedido(false);
      return fluxo;
    }
  };
  const getConfigSLa = async () => {
    setLoadingSla(true);
    if (controllerDashboard) {
      controllerDashboard.abort();
    }
    const newController = new AbortController();
    const signal = newController.signal;
    setControllerDashboard(newController);

    try {
      const response = await api.get("/interno/find/configSla", {
        signal,
      });

      setConfigSla(adicionarCores(response?.data));
      setEditEtapasConfigSla(formtEditConfigSla(response?.data));
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Erro ao buscar configurações de SLA",
        severity: "error",
      });
    } finally {
      setLoadingSla(false);
    }
  };

  const createConfigSLa = async () => {
    setLoadingSla(true);
    if (controllerDashboard) {
      controllerDashboard.abort();
    }
    const newController = new AbortController();
    const signal = newController.signal;
    setControllerDashboard(newController);
    const dataConfigSla = formatArrayConfigSla();

    try {
      const response = await api.post(
        "/interno/create/configSla",
        { configSla: dataConfigSla },
        { signal },
      );

      setConfigSla(adicionarCores(response?.data));
      setEditEtapasConfigSla(formtEditConfigSla(response?.data));
      getFluxoAtendimento();
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Erro ao atualizar dados de SLA",
        severity: "error",
      });
    } finally {
      setLoadingSla(false);
      setIsEditConfigSla(false);
    }
  };

  const refrashAtendimentos = (idAtendimento) => {
    setFluxoAtendimento((prev) =>
      prev.map((etapa) => {
        if (!etapa.atendimentos || etapa.atendimentos?.length === 0)
          return etapa;

        // Filtra os atendimentos dessa etapa
        const novosAtendimentos = etapa.atendimentos.filter(
          (item) => item.id_atendimento !== idAtendimento,
        );

        // Se nada mudou, retorna o objeto original (evita rerenders desnecessários)
        if (novosAtendimentos?.length === etapa.atendimentos?.length) {
          return etapa;
        }

        // Caso tenha removido, atualiza o objeto
        return {
          ...etapa,
          atendimentos: novosAtendimentos,
          atendimentosCount: novosAtendimentos?.length,
        };
      }),
    );
    setCountAtendimentos((prev) => prev - 1);
  };
  const getTicketDetailsForProtocolo = async () => {
    setLoadingTicketDetails(true);
    setIsExplicacao(false); //retirar imagem de explicação
    try {
      const response = await api.post(`/interno/ticketDetails/protocolo`, {
        protocolo: searchValueProtocolo?.trim(),
      });

      setTicketDetails(response?.data);
      setItensPublic((prev) => {
        const mensagens = [];
        const anexos = [];
        const anexosCliente = [];
        const rfo = [];
        for (const item of response?.data?.itensTicketPublic || []) {
          if (item?.itemType === "mensagem") {
            mensagens.push(item?.itemId);
          } else if (item?.itemType === "anexo") {
            anexos?.push(item?.itemId);
          } else if (item?.itemType === "anexoCliente") {
            anexosCliente?.push(item?.itemId);
          } else if (item?.itemType === "rfo") {
            rfo?.push(item?.itemId);
          }
        }

        return {
          ...prev,
          mensagens,
          anexos,
          anexosCliente,
          rfo,
        };
      });
    } catch (error) {
      setTicketDetails(null);
      console.log(error);
      setSnackbar({
        children: "Protocolo não encontrado",
        severity: "warning",
      });
    } finally {
      setLoadingTicketDetails(false);
    }
  };
  const getOsDetailsForProtocolo = async () => {
    setLoadingTicketDetails(true);
    setIsExplicacao(false); //retirar imagem de explicação
    try {
      const response = await api.post(`/interno/osDetails/protocolo`, {
        protocolo: searchValueProtocolo?.trim(),
      });

      setOsDetails(response?.data);
    } catch (error) {
      setTicketDetails(null);
      console.log(error);
      setSnackbar({
        children: "Número de OS não encontrado",
        severity: "warning",
      });
    } finally {
      setLoadingTicketDetails(false);
    }
  };
  const ingressar = async (ticketId, userErpId, action) => {
    if (!userErpId) {
      setSnackbar({
        children:
          "Seu usuário ainda não foi vinculado ao usuário do ERP ou você precisar logar novamente",
        severity: "warning",
      });
      return;
    }
    try {
      const response = await api.post("/interno/ticket/ingressar", {
        ticketId: ticketId,
        userErpId: userErpId,
        action: action,
      });

      const novosResponsaveis = response?.data;

      // Atualiza o estado de forma imutável
      setFluxoAtendimento((prevFluxo) => {
        return prevFluxo.map((etapa) => {
          // Função auxiliar para atualizar o atendimento dentro de uma lista
          const atualizarListaAtendimentos = (lista) =>
            lista.map((atendimento) =>
              atendimento.id === ticketId
                ? { ...atendimento, usuario_responsavel: novosResponsaveis }
                : atendimento,
            );

          return {
            ...etapa,
            atendimentos: atualizarListaAtendimentos(etapa.atendimentos),
            atendimentosSlaExcedido: atualizarListaAtendimentos(
              etapa.atendimentosSlaExcedido,
            ),
          };
        });
      });
      setSnackbar({
        children: action
          ? "Você entrou como responsável do ticket"
          : "Você saiu do ticket",
        severity: "success",
      });
    } catch (error) {
      console.error("Erro ao atualizar ticket:", error);
      setSnackbar({
        children: "Error: Ocorreu um erro ao ingressar no ticket",
        severity: "error",
      });
    }
  };
  const getChipStatus = (status) => {
    switch (status) {
      case "fulfilled":
        return (
          <Tooltip title="Mensagem enviada com sucesso">
            <Chip
              size="small"
              sx={{
                ...styles.chipStatus,
                backgroundColor: theme.palette.colors.green.medium, // verde
              }}
              label={
                <Box sx={styles.containerStatusModal}>
                  <Typography sx={styles.titleChipModal}>Sucesso</Typography>
                  <CheckOutlined
                    sx={{
                      fontSize: "15px",
                      color: theme.palette.white.main,
                    }}
                  />
                </Box>
              }
            />
          </Tooltip>
        );

      case "rejected":
        return (
          <Tooltip title="Não foi possível enviar mensagem">
            <Chip
              size="small"
              sx={{
                ...styles.chipStatus,
                backgroundColor: theme.palette.colors.red.dark, // vermelho
              }}
              label={
                <Box sx={styles.containerStatusModal}>
                  <Typography sx={styles.titleChipModal}>Erro</Typography>
                  <ErrorOutlineOutlined
                    sx={{
                      fontSize: "15px",
                      color: theme.palette.white.main,
                    }}
                  />
                </Box>
              }
            />
          </Tooltip>
        );

      default:
        return (
          <Tooltip title="Preparando envio de mensagem">
            <Chip
              size="small"
              sx={{
                ...styles.chipStatus,
                backgroundColor: theme.palette.colors.blue.medium, // laranja
              }}
              label={
                <Box sx={styles.containerStatusModal}>
                  <Typography sx={styles.titleChipModal}>Preparando</Typography>
                  <AccessTimeOutlined
                    sx={{
                      fontSize: "15px",
                      color: theme.palette.white.main,
                    }}
                  />
                </Box>
              }
            />
          </Tooltip>
        );
    }
  };

  const createManyMensagem = async () => {
    setLoadingCreateMensagem(true);
    if (!newMensagem) {
      setError(true);
      return;
    }

    try {
      const arrayTicketId = selectedItems.map((item) => item.id_atendimento);
      const response = await api.post("/interno/createMany/mensagemTicket", {
        mensagem: newMensagem,
        arrayTicketId: arrayTicketId,
      });

      setStatusTicketMensagem(response?.data);
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Error: Não foi possível criar mensagens",
        severity: "error",
      });
    } finally {
      setLoadingCreateMensagem(false);
      setNewMensagem("");
      setError(false);
    }
  };

  const editManyTicketEtapaAtendimento = async () => {
    setLoadingEditFluxo(true);
    if (!newEtapa?.id) {
      setError(true);
      return;
    }

    try {
      setEditedTicket(true);
      const arrayTicket = selectedItems?.map((item) => {
        return {
          idAtendimento: item?.id_atendimento,
          descricao: item?.descricao_abertura,
          id_atendimento_status: item?.id_atendimento_status,
          id_origem_contato: item?.id_origem_contato,
          id_tipo_atendimento: item?.id_tipo_atendimento,
          id_usuario_responsavel: item?.usuario_responsavel || [], //array de ids
          id_fluxo_atendimento_etapa: newEtapa?.id,
        };
      });
      const response = await api.post("/interno/editMany/etapaFluxoTicket", {
        arrayTicket: arrayTicket,
        idEtapaBefore: selectEtapa?.idEtapaFluxoAtendimento,
      });

      setStatusTicketMensagem(response?.data);
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Error: Não foi alterar etapa do ticket",
        severity: "error",
      });
    } finally {
      setLoadingEditFluxo(false);

      setError(false);
      setDisabledSendFluxo(true);
    }
  };
  const getTicketDetails = async (ticketId) => {
    try {
      const response = await api.post("/interno/find/tickets/id", {
        ticketId: ticketId,
      });

      return response?.data;
    } catch (error) {
      console.log(error);
      setSnackbar({
        children: error?.response?.data?.message,
        severity: "error",
      });
    } finally {
    }
  };

  const filtrarAtendimentos = (data, termo) => {
    // Se não houver termo e nenhum técnico selecionado, retorna o array original
    const semFiltro =
      (!termo || termo.trim() === "") &&
      (!tecnicosSelecionados || tecnicosSelecionados?.length === 0) &&
      (!assuntosSelecionados || assuntosSelecionados?.length === 0) &&
      (!prioridadesSelecionados || prioridadesSelecionados?.length === 0) &&
      (!filiaisSelecionados || filiaisSelecionados?.length === 0);

    if (semFiltro) {
      const etapaFluxoAtendimento = data?.find(
        (item) =>
          item?.etapaFluxoAtendimento === selectEtapa?.name ||
          item?.etapaFluxoAtendimento === selectEtapa?.etapaFluxoAtendimento,
      );
      setSelectEtapa(etapaFluxoAtendimento || null);

      return data;
    }

    const termoLower = termo?.toLowerCase?.()?.trim() || "";

    const filter = data
      ?.map((etapa) => {
        const atendimentosFiltrados = etapa?.atendimentos?.filter((a) => {
          const nome = a?.cliente?.nome?.toLowerCase() || "";
          const protocolo = a?.protocolo?.toLowerCase() || "";
          const descricao = a?.descricao_abertura?.toLowerCase() || "";
          const status = a?.status?.toLowerCase() || "";
          const idServico =
            a?.idClienteServico?.toString()?.toLowerCase() || "";
          const userAbertura = a?.usuario_abertura?.toLowerCase() || "";
          const assunto = a?.assunto?.toLowerCase() || "";
          const prioridade = a?.prioridade?.toLowerCase() || "";
          const filial = a?.filial?.toLowerCase() || "";
          const setor = a?.setor?.toLowerCase() || "";
          const idTicket = a?.id_ticket?.toString()?.toLowerCase() || "";
          const usersResponsavel = a?.usuario_responsavel?.some((u) =>
            u.name?.toLowerCase().includes(termoLower),
          );
          // Filtro principal por termo

          const correspondeAoTermo =
            termoLower === "" ||
            nome.includes(termoLower) ||
            protocolo.includes(termoLower) ||
            descricao.includes(termoLower) ||
            status.includes(termoLower) ||
            idServico.includes(termoLower) ||
            userAbertura.includes(termoLower) ||
            usersResponsavel ||
            assunto.includes(termoLower) ||
            prioridade.includes(termoLower) ||
            filial.includes(termoLower) ||
            setor.includes(termoLower) ||
            idTicket?.includes(termoLower);

          // Filtro adicional pelos técnicos selecionados
          const filterTecnicos =
            !tecnicosSelecionados ||
            tecnicosSelecionados?.length === 0 ||
            tecnicosSelecionados.some((t) => t.toLowerCase() === userAbertura);

          const filterAssuntos =
            !assuntosSelecionados ||
            assuntosSelecionados?.length === 0 ||
            assuntosSelecionados.some((t) => t.toLowerCase() === assunto);

          const filterPrioridades =
            !prioridadesSelecionados ||
            prioridadesSelecionados?.length === 0 ||
            prioridadesSelecionados.some((t) => t.toLowerCase() === prioridade);
          // Só mantém se atender ambos

          const filterFiliais =
            !filiaisSelecionados ||
            filiaisSelecionados?.length === 0 ||
            filiaisSelecionados.some((t) => t.toLowerCase() === filial);
          return (
            correspondeAoTermo &&
            filterTecnicos &&
            filterAssuntos &&
            filterPrioridades &&
            filterFiliais
          );
        });

        return {
          ...etapa,
          atendimentos: atendimentosFiltrados,
          atendimentosCount: atendimentosFiltrados?.length,
        };
      })
      ?.filter((etapa) => etapa.atendimentos?.length > 0);

    setSelectEtapa(filter?.[0] || null);

    return filter;
  };

  function formatEtapasForChart(etapas) {
    if (!etapas || etapas?.length === 0) return [];

    return etapas?.map((etapa) => ({
      etapaFluxoAtendimento: etapa?.etapaFluxoAtendimento,
      atendimentosCount: etapa?.atendimentos?.length || 0,
      posicao: etapa?.posicao,
    }));
  }
  function adicionarCores(objetos) {
    return objetos?.map((obj, index) => ({
      ...obj,
      color: colors[index % colors?.length],
    }));
  }

  function adicionarCoresModalDetails(objetos) {
    return objetos?.reduce((acc, item, index) => {
      acc[item] = colors[index % colors?.length];
      return acc;
    }, {});
  }

  function converterMinutos(totalMinutos) {
    if (!totalMinutos)
      return {
        text: "Não configurado",
        hora: 0,
        minuto: 0,
      };
    const horas = Math.floor(totalMinutos / 60);
    const minutos = totalMinutos % 60;

    return { text: `${horas}h ${minutos}m`, hora: horas, minuto: minutos };
  }

  const statusChamado = {
    "Aguardando Análise": 1,
    Resolvido: 2,
    Pendente: 3,
    Cancelado: 4,
    Aberto: 5,
    Encaminhado: 6,
    Agendado: 7,
    "Em Análise": 8,
    Assumido: 9,
    "Em execução": 10,
    Finalizado: 11,
    Deslocamento: 12,
  };
  const handleSelectEtapa = () => {
    const etapaFluxoAtendimento = filterAtendimentos?.find(
      (item) =>
        item?.etapaFluxoAtendimento === selectEtapa?.name ||
        item?.etapaFluxoAtendimento === selectEtapa?.etapaFluxoAtendimento,
    );

    setSelectEtapaFluxo(etapaFluxoAtendimento);
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedItems(selectEtapaFluxo?.atendimentos); // seleciona todos
    } else {
      setSelectedItems([]); // limpa todos
    }
  };
  const handleOpen = () => setOpen(true);
  const handleOpenModalEtapa = () => {
    setOpenModalEtapa(true);
    setNewEtapa({
      id: selectEtapa?.idEtapaFluxoAtendimento,
      descricao: selectEtapa?.etapaFluxoAtendimento,
    });
  };

  const handleClose = () => {
    if (loadingEditFluxo || loadingCreateMensagem) return;
    setOpen(false);

    setStatusTicketMensagem({});
    setNewMensagem("");
    setOpenModalEtapa(false);
    setDisabledSendFluxo(false);

    if (editedTicket) {
      setEditedTicket(false);
      getFluxoAtendimento();
    }
  };

  const handleCloseNewTicket = () => {
    setOpenNewTicket(false);
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangeTypeSearch = (event) => {
    setTypeSearch(event.target.value);
  };
  const handleOpenSearch = () => setOpenSearch(true);
  const handleOpenConfigSla = () => {
    setOpenConfigSla(true);
    getConfigSLa();
  };
  const handleOpenNewTicket = () => {
    setOpenNewTicket(true);
  };
  const handleCloseSearch = () => {
    setConfirmacaoSaidaPagina(false);
    setIsEditTicket(false);
    setIsFinishTicket(false);
    setIsEditOs(false);
    setIsNewOs(false);
    setIsExplicacao(true);
    setOpenSearch(false);
    setTicketDetails(null);
    setOsDetails(null);
    setSearchValueProtocolo("");
    setValue(0);
    if (editedTicket) {
      setEditedTicket(false);
      getFluxoAtendimento();
    }
  };
  const handleCloseConfigSla = () => {
    setOpenConfigSla(false);
    setIsEditConfigSla(false);
  };
  function formtEditConfigSla(configSla) {
    const resultado = {};

    configSla?.forEach((item) => {
      const { hora, minuto } = converterMinutos(item?.time);
      const { hora: horaIdle, minuto: minutoIdle } = converterMinutos(
        item?.timeIdle,
      );

      resultado[item.idFluxoAtendimentoEtapa] = {
        horas: hora,
        minutos: minuto,
        action: item?.action,
        actionIdle: item?.actionIdle,
        timeAction: item?.timeAction,
        timeActionIdle: item?.timeActionIdle,
        horasIdle: horaIdle,
        minutosIdle: minutoIdle,
      };
    });

    return resultado;
  }

  const toggleDrawer = (newOpen) => {
    setOpenDrawer(newOpen);
  };
  const partiallySelected =
    selectedItems?.length > 0 &&
    selectedItems?.length < selectEtapaFluxo?.atendimentos?.length;

  const allSelected =
    selectEtapaFluxo?.atendimentos?.length > 0 &&
    selectedItems?.length === selectEtapaFluxo?.atendimentos?.length;

  const actions = [
    ...(erp === "HUBSOFT" && isAdmin
      ? [
          {
            icon: <SettingsOutlined />,
            name: "Configurar SLA",
            onClick: () => handleOpenConfigSla(),
          },
        ]
      : []),
    {
      icon: <FilterAltOutlined />,
      name: "Filtro",
      onClick: () => setOpenFilter(true),
    },
    {
      icon: <TravelExploreOutlined />,
      name: "Atualizar",
      onClick: () => handleOpenSearch(),
    },

    {
      icon: <Cached />,
      name: "Atualizar",
      onClick: () => getFluxoAtendimento(),
    },
    ...(erp === "HUBSOFT" || erp === "IXC"
      ? [
          {
            icon: <AddOutlined />,
            name: "Novo Ticket",
            onClick: () => handleOpenNewTicket(),
          },
        ]
      : []),
  ];

  const handleChangeTecnicos = (novosValores) => {
    setTecnicosSelecionados(novosValores);
  };
  const handleCloseTecnicos = () => {};

  const handleChangeAssuntos = (novosValores) => {
    setAssuntosSelecionados(novosValores);
  };
  const handleCloseAssuntos = () => {};

  const handleChangePrioridades = (novosValores) => {
    setPrioridadesSelecionados(novosValores);
  };
  const handleClosePrioridades = () => {};

  const handleChangeFiliais = (novosValores) => {
    setFiliaisSelecionados(novosValores);
  };

  const handleCloseFiliais = () => {};
  const formatArrayConfigSla = () => {
    return configSla.map((sla) => {
      const horas =
        editEtapasConfigSla[sla.idFluxoAtendimentoEtapa]?.horas ?? 0;
      const horasIdle =
        editEtapasConfigSla[sla.idFluxoAtendimentoEtapa]?.horasIdle ?? 0;
      const minutos =
        editEtapasConfigSla[sla.idFluxoAtendimentoEtapa]?.minutos ?? 0;
      const minutosIdle =
        editEtapasConfigSla[sla.idFluxoAtendimentoEtapa]?.minutosIdle ?? 0;
      const action = editEtapasConfigSla[sla.idFluxoAtendimentoEtapa]?.action;
      const actionIdle =
        editEtapasConfigSla[sla.idFluxoAtendimentoEtapa]?.actionIdle;
      const timeAction =
        editEtapasConfigSla[sla.idFluxoAtendimentoEtapa]?.timeAction || 5;
      const timeActionIdle =
        editEtapasConfigSla[sla.idFluxoAtendimentoEtapa]?.timeActionIdle || 5;

      return {
        idFluxoAtendimentoEtapa: sla.idFluxoAtendimentoEtapa,
        time: horas * 60 + minutos,
        action: action,
        timeAction: timeAction,
        timeIdle: horasIdle * 60 + minutosIdle,
        actionIdle: actionIdle,
        timeActionIdle: timeActionIdle,
      };
    });
  };
  const handleCancelNavigation = () => {
    setConfirmacaoSaidaPagina(false);
  };

  return (
    <>
      <FilterBar
        actions={actions}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        type={1}
        selectorComponentLeft={
          <Box
            sx={{
              display: "flex",
              "@media (max-width: 1349px)": { flexDirection: "column" },
              gap: 1,
              width: "100%",
            }}
          >
            {" "}
            <TextField
              id="input-with-icon-textfield"
              size="small"
              label="Buscar ticket"
              variant="outlined"
              autoComplete="off"
              placeholder="Protocolo, responsável, cliente, etc..."
              sx={styles.search}
              value={buscarTicket}
              onChange={(event) => {
                setBuscarTicket(event?.target?.value?.trimStart());
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
                endAdornment: buscarTicket ? (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={() => setBuscarTicket("")}
                      edge="end"
                    >
                      <Clear size={"small"} />
                    </IconButton>
                  </InputAdornment>
                ) : null,
              }}
            />
            {(erp === "IXC" || erp === "VOALLE") && (
              <>
                {assuntos?.length > 0 && (
                  <Box sx={styles.search}>
                    <SelectFilter
                      label={configParamsErp("assunto")}
                      options={assuntos}
                      value={assuntosSelecionados}
                      onChange={handleChangeAssuntos}
                      onClose={handleCloseAssuntos}
                    />
                  </Box>
                )}
                {filiais?.length > 0 && (
                  <Box sx={styles.search}>
                    <SelectFilter
                      label={configParamsErp("filial")}
                      options={filiais}
                      value={filiaisSelecionados}
                      onChange={handleChangeFiliais}
                      onClose={handleCloseFiliais}
                    />
                  </Box>
                )}
                {prioridades?.length > 0 && (
                  <Box sx={styles.search}>
                    <SelectFilter
                      label="Prioridade"
                      options={prioridades}
                      value={prioridadesSelecionados}
                      onChange={handleChangePrioridades}
                      onClose={handleClosePrioridades}
                    />
                  </Box>
                )}
                {tecnicos?.length > 0 && (
                  <Box sx={styles.search}>
                    <SelectFilter
                      label="Técnico"
                      options={tecnicos}
                      value={tecnicosSelecionados}
                      onChange={handleChangeTecnicos}
                      onClose={handleCloseTecnicos}
                    />
                  </Box>
                )}
              </>
            )}
          </Box>
        }
        selectorComponentRight={
          <>
            {windowWidth >= 1350 && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {erp === "HUBSOFT" && isAdmin && (
                  <>
                    <Tooltip title="Configurar SLA">
                      <Button
                        size="small"
                        variant="outlined"
                        disabled={loading}
                        onClick={() => handleOpenConfigSla()}
                        sx={styles.buttonSearch}
                      >
                        <SettingsOutlined
                          fontSize="small"
                          sx={{ color: theme.palette.text.main }}
                          className={loading ? "rotating" : ""}
                        />
                      </Button>
                    </Tooltip>
                  </>
                )}

                <Tooltip title="Busca global">
                  <Button
                    size="small"
                    variant="outlined"
                    disabled={loading}
                    onClick={() => handleOpenSearch()}
                    sx={styles.buttonSearch}
                  >
                    <TravelExploreOutlined
                      fontSize="small"
                      sx={{ color: theme.palette.text.main }}
                      className={loading ? "rotating" : ""}
                    />
                  </Button>
                </Tooltip>
                <Tooltip title="Atualizar">
                  <Button
                    size="small"
                    variant="outlined"
                    disabled={loading}
                    onClick={() => getFluxoAtendimento()}
                    sx={styles.buttonRefresh}
                  >
                    <Cached
                      fontSize="small"
                      sx={{ color: theme.palette.text.main }}
                      className={loading ? "rotating" : ""}
                    />
                  </Button>
                </Tooltip>
                {(erp === "HUBSOFT" || erp === "IXC") && (
                  <Tooltip title="Novo Ticket">
                    <Button
                      startIcon={<AddOutlined fontSize="small" />}
                      variant="contained"
                      disabled={loading}
                      sx={{ width: 133, height: 43 }}
                      onClick={() => handleOpenNewTicket()}
                    >
                      Novo ticket
                    </Button>
                  </Tooltip>
                )}
              </Box>
            )}
          </>
        }
      />
      {loading ? (
        <Box sx={{ mt: 20 }}>
          <LoaderThreeDots />
        </Box>
      ) : filterAtendimentos?.length === 0 ? (
        <Box sx={{ mt: 10, display: "flex", justifyContent: "center" }}>
          <ConfusedMale
            mainFill={theme.palette.background.paper}
            primaryCircleFill={theme.palette.primary.main}
            highlightTitle={"Oops!"}
            subtitle={"Parece que não encontramos\nnenhum fluxo de atendimento"}
            highlightSubtitle={"por aqui..."}
          />
        </Box>
      ) : (
        <>
          <Box sx={styles.boxHeader}>
            <Box sx={styles.containerStackedBarChart}>
              <StackedBarChart
                colors={colors}
                isPropertyColor={isPropertyColor}
                setSelectEtapa={setSelectEtapa}
                data={formatEtapasForChart(filterAtendimentos)}
                selectEtapaFluxo={selectEtapaFluxo}
                property="etapaFluxoAtendimento"
                toggleDrawer={toggleDrawer}
                windowWidth={windowWidth}
                titulo={
                  fluxoAtendimento?.[0]?.descricaoFluxoAtendimento &&
                  `${fluxoAtendimento?.[0]?.descricaoFluxoAtendimento} - (${countAtendimentos})`
                }
              />
            </Box>
          </Box>
          <Box sx={styles.boxBody}>
            <Grid
              container
              spacing={1}
              columns={{
                xs: 8,
                sm: 8,
                smx: 12,
                md: 12,
                lg: 12,
                xl: 12,
                xxl: 12,
              }}
            >
              <Grid
                sx={styles.paperFluxo}
                item
                xs={8}
                sm={8}
                smx={4}
                md={4}
                lg={4}
              >
                <Paper
                  elevation={theme.palette.mode === "dark" ? 0 : 3}
                  sx={{ ...styles.paperFluxo }}
                >
                  <FluxoAtendimento
                    fluxoAtendimento={filterAtendimentos}
                    loading={loading}
                    isPropertyColor={isPropertyColor}
                    setSelectEtapa={setSelectEtapa}
                    selectEtapaFluxo={selectEtapaFluxo}
                    toggleDrawer={toggleDrawer}
                    windowWidth={windowWidth}
                    converterMinutos={converterMinutos}
                  />
                </Paper>
              </Grid>{" "}
              {windowWidth >= 750 && (
                <Grid
                  sx={styles.paperFluxo}
                  item
                  xs={8}
                  sm={8}
                  smx={8}
                  md={8}
                  lg={8}
                >
                  {erp === "HUBSOFT" && (
                    <FluxoTickets
                      theme={theme}
                      styles={styles}
                      selectEtapaFluxo={selectEtapaFluxo}
                      isSelecting={isSelecting}
                      allSelected={allSelected}
                      partiallySelected={partiallySelected}
                      selectedItems={selectedItems}
                      handleSelectAll={handleSelectAll}
                      handleToggleSelectMode={handleToggleSelectMode}
                      handleOpen={handleOpen}
                      handleSelectItem={handleSelectItem}
                      getTicketDetails={getTicketDetails}
                      setSnackbar={setSnackbar}
                      labelErp={labelErp}
                      refreshAtendimentos={getFluxoAtendimento}
                      allEtapasFluxoAtendimentos={allEtapasFluxoAtendimento}
                      windowWidth={windowWidth}
                      handleOpenModalEtapa={handleOpenModalEtapa}
                      ingressar={ingressar}
                    />
                  )}
                  {(erp === "IXC" || erp === "VOALLE") && (
                    <FluxoAtendimentoIxc
                      theme={theme}
                      styles={styles}
                      allEtapasFluxoAtendimentos={allEtapasFluxoAtendimento}
                      selectEtapaFluxo={selectEtapaFluxo}
                      isSelecting={isSelecting}
                      allSelected={allSelected}
                      partiallySelected={partiallySelected}
                      selectedItems={selectedItems}
                      handleSelectAll={handleSelectAll}
                      handleToggleSelectMode={handleToggleSelectMode}
                      handleOpen={handleOpen}
                      handleSelectItem={handleSelectItem}
                      getTicketDetails={getTicketDetails}
                      setSnackbar={setSnackbar}
                      refreshAtendimentos={getFluxoAtendimento}
                      labelErp={labelErp}
                      statusChamado={statusChamado}
                      isAtendimento={true}
                    />
                  )}
                </Grid>
              )}
            </Grid>
          </Box>
        </>
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styles.modal}>
          <Box sx={styles.containerModal}>
            <Box>
              <Typography sx={styles.titleModal}>
                Enviar mensagem para:
              </Typography>
              <Paper variant="outlined" sx={styles.paperAllTickets}>
                {selectedItems?.map((item) => (
                  <Paper variant="outlined" sx={styles.paperTickets}>
                    <Box sx={{ overflow: "hidden" }}>
                      <Box sx={styles.boxData}>
                        <Typography sx={styles.titleDataModal}>
                          Protocolo:
                        </Typography>
                        <Typography sx={styles.titleDataProtocoloModal}>
                          {item?.protocolo}
                        </Typography>
                      </Box>

                      <Box sx={styles.boxData}>
                        <Typography sx={styles.titleDataModal}>
                          Cliente:
                        </Typography>
                        <Typography sx={styles.titleDataClienteModal}>
                          {item?.cliente?.nome}
                        </Typography>
                      </Box>
                    </Box>
                    {loadingCreateMensagem ? (
                      <Box sx={styles.containerStatusMensagem}>
                        <Typography sx={styles.titleDataModal}>
                          Status de envio:
                        </Typography>
                        <CircularProgress size={20} />
                      </Box>
                    ) : (
                      <Box sx={styles.containerStatusMensagem}>
                        <Typography sx={styles.titleDataModal}>
                          Status de envio:
                        </Typography>
                        {getChipStatus(
                          statusTicketMensagem[
                            item?.id_atendimento?.toString()
                          ],
                        )}
                      </Box>
                    )}
                  </Paper>
                ))}
              </Paper>
            </Box>
            <Box sx={styles.containerSendMensagem}>
              <TextField
                sx={{ width: "100%" }}
                error={error && !newMensagem?.trim()}
                helperText={
                  !newMensagem?.trim() && error && "Campo obrigatorio"
                }
                disabled={loadingCreateMensagem}
                placeholder="Mensagem"
                label="Mensagem"
                multiline
                rows={4}
                value={newMensagem}
                onChange={(e) => setNewMensagem(e.target.value)}
              />
              <Box sx={styles.containerActionsMensagens}>
                <Button disabled={loadingCreateMensagem} onClick={handleClose}>
                  Cancelar
                </Button>
                <LoadingButton
                  onClick={createManyMensagem}
                  loading={loadingCreateMensagem}
                  disabled={loadingCreateMensagem || !newMensagem?.trim()}
                  variant="contained"
                >
                  Enviar
                </LoadingButton>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={openModalEtapa || loadingEditFluxo}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styles.modal}>
          <Box sx={styles.containerModal}>
            <Box>
              <Typography sx={styles.titleModal}>
                Alterar etapa dos atendimentos:
              </Typography>
              <Paper
                variant="outlined"
                sx={{ ...styles.paperAllTickets, height: "475px" }}
              >
                {selectedItems.map((item) => (
                  <Paper variant="outlined" sx={styles.paperTickets}>
                    <Box sx={{ overflow: "hidden" }}>
                      <Box sx={styles.boxData}>
                        <Typography sx={styles.titleDataModal}>
                          Protocolo:
                        </Typography>
                        <Typography sx={styles.titleDataProtocoloModal}>
                          {item?.protocolo}
                        </Typography>
                      </Box>

                      <Box sx={styles.boxData}>
                        <Typography sx={styles.titleDataModal}>
                          Cliente:
                        </Typography>
                        <Typography sx={styles.titleDataClienteModal}>
                          {item?.cliente?.nome}
                        </Typography>
                      </Box>
                    </Box>
                    {loadingEditFluxo ? (
                      <Box sx={styles.containerStatusMensagem}>
                        <Typography sx={styles.titleDataModal}>
                          Status de envio:
                        </Typography>
                        <CircularProgress size={20} />
                      </Box>
                    ) : (
                      <Box sx={styles.containerStatusMensagem}>
                        <Typography sx={styles.titleDataModal}>
                          Status de envio:
                        </Typography>
                        {getChipStatus(
                          statusTicketMensagem[
                            item?.id_atendimento?.toString()
                          ],
                        )}
                      </Box>
                    )}
                  </Paper>
                ))}
              </Paper>
            </Box>
            <Box sx={styles.containerSendMensagem}>
              <VirtualizedAutocomplete
                size="small"
                options={objectEtapas}
                /*  disabled={
                !dataTicket?.cnpj || loadingServicos || loadingCreateTicket
              }  */
                value={
                  objectEtapas?.find((etapa) => etapa?.id === newEtapa?.id) ||
                  null
                }
                getOptionLabel={(option) =>
                  option ? `${option?.descricao}` : ""
                }
                onChange={(event, value) => {
                  setNewEtapa((prev) => ({
                    id: value?.id,
                    descricao: value?.descricao,
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    variant="filled"
                    label="Etapa fluxo atendimento"
                    /*   error={error && !dataTicket?.clienteServicoId} */
                    /* helperText={
                    error &&
                    !dataTicket?.clienteServicoId &&
                    "Campo obrigatório"
                  } */
                  />
                )}
              />
              <Box sx={styles.containerActionsMensagens}>
                <Button disabled={loadingEditFluxo} onClick={handleClose}>
                  Cancelar
                </Button>
                <LoadingButton
                  onClick={editManyTicketEtapaAtendimento}
                  loading={loadingEditFluxo}
                  disabled={
                    loadingCreateMensagem || !newEtapa?.id || disabledSendFluxo
                  }
                  variant="contained"
                >
                  Encaminhar
                </LoadingButton>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>

      <>
        {erp === "HUBSOFT" && ticketDetails ? (
          <TicketModalContent
            open={openSearch} // Controla a abertura do Drawer internamente
            handleClose={handleCloseSearch} // Passa apenas a função limpa, sem as validações do pai
            erp={erp}
            ticketDetails={ticketDetails}
            status={ticketDetails?.status}
            labelTabsErp={labelTabsErp}
            value={value}
            handleChange={handleChange}
            isEdit={true}
            setTicketDetails={setTicketDetails}
            itensPublic={itensPublic}
            setItensPublic={setItensPublic}
            setSnackbar={setSnackbar}
            fluxoAtendimentoColor={adicionarCoresModalDetails(
              ticketDetails?.allEtapasFluxoAtendimentos,
            )}
            setEditedTicket={setEditedTicket}
            setIsEditTicket={setIsEditTicket}
            isEditTicket={isEditTicket}
            setIsFinishTicket={setIsFinishTicket}
            isFinishTicket={isFinishTicket}
            isEditOs={isEditOs}
            setIsEditOs={setIsEditOs}
            setIsNewOs={setIsNewOs}
            isNewOs={isNewOs}
          />
        ) : (erp === "IXC" || erp === "VOALLE") &&
          (ticketDetails || osDetails) ? (
          <TicketModalContentIxc
            open={openSearch}
            handleClose={handleCloseSearch}
            erp={erp}
            ticketDetails={ticketDetails}
            status={ticketDetails?.status}
            labelTabsErp={labelTabsErp}
            value={value}
            handleChange={handleChange}
            isEdit={true}
            setTicketDetails={setTicketDetails}
            itensPublic={itensPublic}
            setItensPublic={setItensPublic}
            setSnackbar={setSnackbar}
            isAtendimento={true}
            setIsEditTicket={setIsEditTicket}
            isEditTicket={isEditTicket}
            isEditOs={isEditOs}
            setIsEditOs={setIsEditOs}
            setIsNewOs={setIsNewOs}
            isNewOs={isNewOs}
          />
        ) : (
          <Modal
            open={openSearch}
            onClose={() =>
              isEditTicket || isFinishTicket || isEditOs || isNewOs
                ? setConfirmacaoSaidaPagina(true)
                : handleCloseSearch()
            }
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            {ticketDetails || osDetails ? (
              <>
                {erp === "HUBSOFT" && (
                  <>
                    {/* O TicketModalContent foi removido daqui e colocado na condição externa */}
                    {osDetails && (
                      <OsModalComponent
                        osDetails={osDetails}
                        setOsDetails={setOsDetails}
                        /* isEdit={isEdit} */
                        setOpenEditOS={setIsEditOs}
                        openEditOS={isEditOs}
                        setOpenNewOs={setIsNewOs}
                        openNewOs={isNewOs}
                        handleCloseSearchOs={() =>
                          isEditTicket || isFinishTicket || isEditOs || isNewOs
                            ? setConfirmacaoSaidaPagina(true)
                            : handleCloseSearch()
                        }
                      />
                    )}

                    <InternoModalConfirmacaoSaida
                      openConfirmacao={confirmacaoSaidaPagina}
                      confirmLoad={false}
                      setOpenConfirmacao={setConfirmacaoSaidaPagina}
                      execute={handleCloseSearch}
                      cancel={handleCancelNavigation}
                      severity={"warning"}
                      title={"Atenção"}
                      contentText={
                        "As alterações não salvas serão perdidas, deseja continuar?"
                      }
                      headerText={"Você está prestes a sair do modo de edição."}
                      confirmText={"Continuar"}
                    />
                  </>
                )}
              </>
            ) : (
              <Box sx={styles.modalSearch}>
                <Box sx={styles.containerBoxClearSearch}>
                  <IconButton>
                    <ClearOutlined onClick={handleCloseSearch} />
                  </IconButton>
                </Box>
                <Box
                  component="form"
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (searchValueProtocolo?.trim() && !loadingTicketDetails) {
                      if (typeSearch === "ticket") {
                        getTicketDetailsForProtocolo();
                      } else if (typeSearch === "os") {
                        getOsDetailsForProtocolo();
                      }
                    }
                  }}
                  sx={styles.containerSearch}
                >
                  <TextField
                    sx={{ width: "100%" }}
                    size="small"
                    placeholder={
                      typeSearch === "ticket"
                        ? "Digite o protocolo do ticket"
                        : "Digite o número da OS"
                    }
                    autoComplete="off"
                    label={
                      typeSearch === "ticket" ? "Protocolo" : "Número da OS"
                    }
                    value={searchValueProtocolo}
                    onChange={(e) => setSearchValueProtocolo(e.target.value)}
                    disabled={loadingTicketDetails}
                  />
                  {erp === "HUBSOFT" && (
                    <FormControl sx={{ width: "150px" }} size="small">
                      <InputLabel id="demo-simple-select-label">
                        Tipo
                      </InputLabel>
                      <Select
                        disabled={loadingTicketDetails}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={typeSearch}
                        label="Tipo"
                        onChange={handleChangeTypeSearch}
                      >
                        <MenuItem value={"ticket"}>Ticket</MenuItem>
                        <MenuItem value={"os"}>OS</MenuItem>
                      </Select>
                    </FormControl>
                  )}

                  <Button
                    size="small"
                    variant="contained"
                    type="submit"
                    disabled={
                      loadingTicketDetails || !searchValueProtocolo?.trim()
                    }
                    sx={styles.buttonSearchModal}
                  >
                    <SearchOutlined fontSize="small" />
                  </Button>
                </Box>

                <Box sx={styles.boxNoTickets}>
                  {loadingTicketDetails ? (
                    <CircularProgress size={30} color="secondary" />
                  ) : (
                    <>
                      {isExplicacao && (
                        <InformationMaleNoBack
                          backgroundGradinetDark={
                            theme.palette.buttonHoverGradient.dark
                          }
                          backgroundGradinetLight={
                            theme.palette.buttonHoverGradient.light
                          }
                          title={`Pesquise qualquer ${typeSearch === "ticket" ? "ticket" : "OS"} por`}
                          highlight={
                            typeSearch === "ticket"
                              ? "protocolo"
                              : "número da OS"
                          }
                        />
                      )}
                      {!isExplicacao && !ticketDetails && (
                        <ConfusedMaleNoBack
                          primaryCircleFill={theme.palette.primary.main}
                          highlightTitle={"Oops!"}
                          subtitle={
                            typeSearch === "ticket"
                              ? "Parece que não encontramos\nnenhum ticket referente\na esse"
                              : typeSearch === "os"
                                ? "Parece que não encontramos\nnenhuma OS referente\na esse"
                                : "Parece que não encontramos\nnenhum ticket ou OS referente\na esse"
                          }
                          highlightSubtitle={
                            typeSearch === "ticket"
                              ? "protocolo"
                              : typeSearch === "os"
                                ? "número de OS."
                                : "número"
                          }
                        />
                      )}
                    </>
                  )}
                </Box>
              </Box>
            )}
          </Modal>
        )}
      </>

      <ModalConfigSla
        open={openConfigSla}
        onClose={handleCloseConfigSla}
        loading={loadingSla}
        configSla={configSla}
        isEdit={isEditConfigSla}
        setIsEdit={setIsEditConfigSla}
        editEtapas={editEtapasConfigSla}
        setEditEtapas={setEditEtapasConfigSla}
        handleSave={createConfigSLa}
        handleCancel={handleCloseConfigSla}
        converterMinutos={converterMinutos}
        formtEditConfigSla={formtEditConfigSla}
      />

      <InternoModalConfirmacaoSaida
        openConfirmacao={modalAlertSlaAberto}
        deleteLoad={false}
        // Passamos a função handleCloseModal para que, se ele clicar fora ou no "X", passe pro próximo
        setOpenConfirmacao={handleCloseModal}
        execute={handleCheckTicketSlaExcedido}
        severity={"warning"}
        title={"Atenção"}
        contentText={modalAlerSlaAtual?.mensagem}
        confirmText={"Verificar"}
      />
      <InternoModalConfirmacaoSaida
        openConfirmacao={openModalAlertPrioridade?.open}
        deleteLoad={false}
        // Passamos a função handleCloseModal para que, se ele clicar fora ou no "X", passe pro próximo
        setOpenConfirmacao={() =>
          setOpenModalAlertPrioridade((prev) => ({ ...prev, open: false }))
        }
        execute={() =>
          setOpenModalAlertPrioridade((prev) => ({ ...prev, open: false }))
        }
        severity={"error"}
        title={"Atenção"}
        contentText={openModalAlertPrioridade?.mensagem}
        confirmText={"Verificar"}
        hideCancel={true}
      />

      {erp === "HUBSOFT" && (
        <ModalNewTicket
          open={openNewTicket}
          handleClose={handleCloseNewTicket}
          refrashTIckets={getFluxoAtendimento}
        />
      )}
      {erp === "IXC" && (
        <ModalNewTicketIxc
          open={openNewTicket}
          handleClose={handleCloseNewTicket}
          refrashTIckets={getFluxoAtendimento}
        />
      )}

      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={() => toggleDrawer(false)}
        sx={{ position: "relative" }}
      >
        <Box sx={styles.boxBlurDrawer} />
        <Box sx={styles.containerCloseDrawer}>
          <Box sx={{ p: 1 }}>
            <IconButton onClick={() => toggleDrawer(false)}>
              <KeyboardDoubleArrowRightOutlined />
            </IconButton>
          </Box>

          <Divider />
        </Box>
        <Box sx={{ ...styles.paperFluxo, width: "80vw" }}>
          {erp === "HUBSOFT" && (
            <FluxoTickets
              theme={theme}
              styles={styles}
              selectEtapaFluxo={selectEtapaFluxo}
              setSelectEtapaFluxo={setSelectEtapaFluxo}
              isSelecting={isSelecting}
              allSelected={allSelected}
              partiallySelected={partiallySelected}
              selectedItems={selectedItems}
              handleSelectAll={handleSelectAll}
              handleToggleSelectMode={handleToggleSelectMode}
              handleOpen={handleOpen}
              handleSelectItem={handleSelectItem}
              getTicketDetails={getTicketDetails}
              setSnackbar={setSnackbar}
              labelErp={labelErp}
              refreshAtendimentos={refrashAtendimentos}
              allEtapasFluxoAtendimentos={allEtapasFluxoAtendimento}
              windowWidth={windowWidth}
              handleOpenModalEtapa={handleOpenModalEtapa}
            />
          )}
          {(erp === "IXC" || erp === "VOALLE") && (
            <FluxoAtendimentoIxc
              theme={theme}
              styles={styles}
              selectEtapaFluxo={selectEtapaFluxo}
              isSelecting={isSelecting}
              allSelected={allSelected}
              partiallySelected={partiallySelected}
              selectedItems={selectedItems}
              handleSelectAll={handleSelectAll}
              handleToggleSelectMode={handleToggleSelectMode}
              handleOpen={handleOpen}
              handleSelectItem={handleSelectItem}
              getTicketDetails={getTicketDetails}
              setSnackbar={setSnackbar}
              labelErp={labelErp}
              statusChamado={statusChamado}
            />
          )}
        </Box>
      </Drawer>

      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </>
  );
}
